import React from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import GroupPicture from "web/components/GroupPicture";
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import ProfilePicture from "web/assets/images/userPicDummy.jpeg";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import InviteMemberIcon from "web/assets/svg/InviteMemberIcon";
import MakeAdminIcon from "web/assets/svg/MakeAdminIcon";
import RemoveIcon from "web/assets/svg/RemoveIcon";
import DeleteGroupIcon from "web/assets/svg/DeleteGroupIcon";
import Avatar from "@material-ui/core/Avatar";
import Tooltip from "@material-ui/core/Tooltip";

import {
  AccordionHeader,
  GroupImageWrapper,
  AccordionConatiner,
  AccordionDetailsContainer,
  CreateGroupWrappe,
  BoxActionBtn,
  Description,
} from "web/pages/private/CommonPages/MyNetworks/YourGroups/yourGroupsStyled";

const GroupsAccordions = ({
  groupListResponse,
  closeIconCallBack,
  inviteCallBack,
  pageLanguageContents,
}) => {
  const [expanded, setExpanded] = React.useState(false);

  let profileIconClick = false;
  const handleChange = (panel) => (event, isExpanded) => {
    if (!profileIconClick) {
      setExpanded(isExpanded ? panel : false);
    }
  };
  return (
    <AccordionConatiner>
      {groupListResponse &&
        groupListResponse.map((item, index) => (
          <Accordion
            expanded={expanded === "panel" + index}
            onChange={handleChange("panel" + index)}
            key={index}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <AccordionHeader>
                <GroupImageWrapper>
                  {!item.loggedInUserIsAdmin && (
                    <Avatar
                      alt="Jack Sparrow"
                      src={
                        groupListResponse &&
                          groupListResponse[index].profileImage
                          ? process.env.REACT_APP_API_URL +
                          "/user/image/" +
                          groupListResponse[index].profileImage
                          : ProfilePicture
                      }
                    />
                  )}
                  {item.loggedInUserIsAdmin && (
                    <CreateGroupWrappe>
                      <div className="image-container">
                        <div className="image-wrapper">
                          <GroupPicture
                            name="updateGroupImg"
                            callBackImg={(file) => {
                              closeIconCallBack("groupImgUpdate");
                              profileIconClick = false;
                            }}
                            callBackClickEvent={() => {
                              profileIconClick = true;
                            }}
                            cancelPopupCallBack={() => {
                              profileIconClick = false;
                            }}
                            networkId={item.id}
                            groupListResponse={groupListResponse}
                            index={index}
                            gruopType={"update"}
                            Picture={
                              groupListResponse &&
                                groupListResponse[index].profileImage
                                ? process.env.REACT_APP_API_URL +
                                "/user/image/" +
                                groupListResponse[index].profileImage
                                : ProfilePicture
                            }
                            ProfileName={""}
                            CompanyName=""
                            pageType="Network"
                          />
                        </div>
                      </div>
                    </CreateGroupWrappe>
                  )}
                  
                  <div
                    className={!item.loggedInUserIsAdmin ? "group-name margin-style-1" : "group-name margin-style-2"}
                    onClick={() => {
                    }}
                  >
                    <Tooltip
                      placement="top"
                      arrow
                      title={`${item.networkName.replace(/^(.)|\s+(.)/g, (c) =>
                        c.toUpperCase()
                      )}
                      ${
                        item.appearsInSearchResult
                        ? pageLanguageContents?.CreateGroup[13]?.Public
                        : pageLanguageContents?.CreateGroup[14]?.Private
                        }`}
                      enterTouchDelay={0}
                    >
                      <h3>
                        {item.networkName.replace(/^(.)|\s+(.)/g, (c) =>
                          c.toUpperCase()
                        )}{" "}
                        {item.appearsInSearchResult
                          ? pageLanguageContents?.CreateGroup[13]?.Public
                          : pageLanguageContents?.CreateGroup[14]?.Private}
                      </h3>
                    </Tooltip>

                    {item.companyName === item.locationName ? (
                      <h5>{item.companyName}</h5>
                    ) : (
                        <>
                          <h5>{item.companyName}</h5>
                          <h5>{item.locationName}</h5>
                        </>
                      )}

                    {item.city && item.state && (
                      <h4>
                        {item.city}, {stateConvert(item.state)}
                      </h4>
                    )}

                  </div>
                </GroupImageWrapper>                
                <div>
                  {item.allowMemberToConnection && item.loggedInUserIsAdmin && (
                    <button
                      onClick={() =>
                        inviteCallBack(item.networkName, item, item.id)
                      }
                    >
                      <InviteMemberIcon />
                      {pageLanguageContents?.CreateGroup[16]?.InviteNewMember}
                    </button>
                  )}
                  {item.allowMemberToConnection && !item.loggedInUserIsAdmin && (
                    <button
                      onClick={() =>
                        inviteCallBack(item.networkName, item, item.id)
                      }
                    >
                      <InviteMemberIcon />
                      {pageLanguageContents?.CreateGroup[16]?.InviteNewMember}
                    </button>
                  )}
                  {!item.allowMemberToConnection && item.loggedInUserIsAdmin && (
                    <button
                      onClick={() =>
                        inviteCallBack(item.networkName, item, item.id)
                      }
                    >
                      <InviteMemberIcon />
                      {pageLanguageContents?.CreateGroup[16]?.InviteNewMember}
                    </button>
                  )}                 
                </div>
                <h3>
                  {item.networkMemberInfo.length !== 0
                    ? item.networkMemberInfo.length +
                    (pageLanguageContents?.CreateGroup[15]?.Members)
                    : ""}
                </h3>
              </AccordionHeader>

              {item.description && (
                <Description>{item.description}</Description>
              )}
            </AccordionSummary>
            {!item.loggedInUserIsAdmin && !item.appearsInSearchResult && (
              <>
                {item.networkMemberInfo.length !== 0 && (
                  <AccordionDetails>
                    <AccordionDetailsContainer>
                      {item.networkMemberInfo.map((memberitem, memberIndex) => (
                        <>
                          {(item.networkMemberInfo[memberIndex].loggedIn ||
                            item.networkMemberInfo[memberIndex].admin) && (
                              <AccordionHeader key={memberIndex}>
                                <GroupImageWrapper>
                                  <Avatar
                                    src={
                                      item.networkMemberInfo[memberIndex]
                                        .profileImage
                                        ? process.env.REACT_APP_API_URL +
                                        "/user/image/" +
                                        item.networkMemberInfo[memberIndex]
                                          .profileImage
                                        : ProfilePicture
                                    }
                                    alt="group-image"
                                  />
                                  <div>
                                    {item.networkMemberInfo[memberIndex].admin &&
                                      !item.networkMemberInfo[memberIndex]
                                        .loggedIn && (
                                        <>
                                      <h3>{memberitem.name} ({pageLanguageContents?.CreateGroup[17]?.Admin})
                                          </h3>

                                        </>
                                      )}
                                    {!item.networkMemberInfo[memberIndex].admin &&
                                      !item.networkMemberInfo[memberIndex]
                                        .loggedIn && <h3>{memberitem.name}</h3>}

                                    {item.networkMemberInfo[memberIndex].admin &&
                                      item.networkMemberInfo[memberIndex]
                                        .loggedIn && (
                                        <>
                                          <h3>
                                        {pageLanguageContents?.CreateGroup[18]?.You} ({pageLanguageContents?.CreateGroup[17]?.Admin}
                                            )
                                          </h3>

                                        </>
                                      )}
                                    {!item.networkMemberInfo[memberIndex].admin &&
                                      item.networkMemberInfo[memberIndex]
                                        .loggedIn && (
                                        <h3>
                                      {pageLanguageContents?.CreateGroup[18]?.You}
                                        </h3>
                                      )}
                                    <h3><small>{item.networkMemberInfo[memberIndex].locationName}</small></h3>
                                  <h3><small>{item.networkMemberInfo[memberIndex].city}, {stateConvert(item.networkMemberInfo[memberIndex].state)}</small></h3>
                                  </div>
                                </GroupImageWrapper>
                                <>
                                  <BoxActionBtn>
                                    {(item.loggedInUserIsAdmin ||
                                      (item.networkMemberInfo[memberIndex]
                                        .admin &&
                                        item.networkMemberInfo[memberIndex]
                                          .loggedIn)) && (
                                        <button
                                          onClick={() => {
                                            inviteCallBack(
                                              "deleteGroup",
                                              item,
                                              item.networkMemberInfo[memberIndex]
                                                .userId
                                            );
                                            setExpanded(false);
                                          }}
                                        >
                                          <DeleteGroupIcon />
                                      {pageLanguageContents?.CreateGroup[19]?.DeleteGroup}
                                        </button>
                                      )}

                                    {item.loggedInUserIsAdmin &&
                                      item.networkMemberInfo[memberIndex].admin &&
                                      !item.networkMemberInfo[memberIndex]
                                        .loggedIn && (
                                        <button
                                          onClick={() =>
                                            inviteCallBack(
                                              "remove",
                                              item,
                                              item.networkMemberInfo[memberIndex]
                                                .userId
                                            )
                                          }
                                        >
                                          <RemoveIcon />
                                      {pageLanguageContents?.CreateGroup[20]?.Remove}
                                        </button>
                                      )}

                                    {!item.networkMemberInfo[memberIndex].admin &&
                                      item.networkMemberInfo[memberIndex]
                                        .loggedIn && (
                                        <button
                                          onClick={() =>
                                            inviteCallBack(
                                              "exit",
                                              item,
                                              item.networkMemberInfo[memberIndex]
                                                .userId
                                            )
                                          }
                                        >
                                          <RemoveIcon />
                                      {pageLanguageContents?.CreateGroup[21]?.ExitGroup}
                                        </button>
                                      )}
                                  </BoxActionBtn>
                                </>
                              </AccordionHeader>
                            )}
                        </>
                      ))}
                    </AccordionDetailsContainer>
                  </AccordionDetails>
                )}
              </>
            )}
            {!item.loggedInUserIsAdmin && item.appearsInSearchResult && (
              <>
                {item.networkMemberInfo.length !== 0 && (
                  <AccordionDetails>
                    <AccordionDetailsContainer>
                      {item.networkMemberInfo.map((memberitem, memberIndex) => (
                        <>
                          <AccordionHeader key={memberIndex}>
                            <GroupImageWrapper>
                              <Avatar
                                src={
                                  item.networkMemberInfo[memberIndex]
                                    .profileImage
                                    ? process.env.REACT_APP_API_URL +
                                    "/user/image/" +
                                    item.networkMemberInfo[memberIndex]
                                      .profileImage
                                    : ProfilePicture
                                }
                                alt="group-image"
                              />

                              <div>
                                {item.networkMemberInfo[memberIndex].admin &&
                                  !item.networkMemberInfo[memberIndex]
                                    .loggedIn && (
                                    <>
                                    <h3>{memberitem.name} ({pageLanguageContents?.CreateGroup[17]?.Admin}
                                        )</h3>

                                    </>
                                  )}
                                {!item.networkMemberInfo[memberIndex].admin &&
                                  !item.networkMemberInfo[memberIndex]
                                    .loggedIn && <h3>{memberitem.name}</h3>}

                                {item.networkMemberInfo[memberIndex].admin &&
                                  item.networkMemberInfo[memberIndex]
                                    .loggedIn && (
                                    <>
                                      <h3>
                                      {pageLanguageContents?.CreateGroup[18]?.You} ({pageLanguageContents?.CreateGroup[17]?.Admin})
                                      </h3>
                                    </>
                                  )}
                                {!item.networkMemberInfo[memberIndex].admin &&
                                  item.networkMemberInfo[memberIndex]
                                    .loggedIn && (
                                    <h3>
                                    {pageLanguageContents?.CreateGroup[18]?.You}
                                    </h3>
                                  )}
                                <h3><small>{item.networkMemberInfo[memberIndex].locationName}</small></h3>
                                <h3><small>{item.networkMemberInfo[memberIndex].city}, {stateConvert(item.networkMemberInfo[memberIndex].state)}</small></h3>
                              </div>
                            </GroupImageWrapper>

                            <>
                              {item.loggedInUserIsAdmin &&
                                item.networkMemberInfo[memberIndex]
                                  .loggedIn && (
                                  <>
                                    <BoxActionBtn>
                                      <button
                                        onClick={() => {
                                          inviteCallBack(
                                            "deleteGroup",
                                            item,
                                            item.networkMemberInfo[memberIndex]
                                              .userId
                                          );
                                          setExpanded(false);
                                        }}
                                      >
                                        <DeleteGroupIcon />
                                      {pageLanguageContents?.CreateGroup[19]?.DeleteGroup}
                                      </button>
                                      <button
                                        onClick={() =>
                                          inviteCallBack(
                                            "exit",
                                            item,
                                            item.networkMemberInfo[memberIndex]
                                              .userId
                                          )
                                        }
                                      >
                                        <RemoveIcon />
                                      {pageLanguageContents?.CreateGroup[21]?.ExitGroup}
                                      </button>
                                    </BoxActionBtn>
                                  </>
                                )}
                              {item.loggedInUserIsAdmin &&
                                !item.networkMemberInfo[memberIndex]
                                  .loggedIn && (
                                  <>
                                    <BoxActionBtn>
                                      {!item.networkMemberInfo[memberIndex]
                                        .admin && (
                                          <button
                                            onClick={() =>
                                              inviteCallBack(
                                                "makeAdmin",
                                                item,
                                                item.networkMemberInfo[
                                                  memberIndex
                                                ].authId
                                              )
                                            }
                                          >
                                            <MakeAdminIcon />
                                        {pageLanguageContents?.CreateGroup[22]?.MakeAdmin}
                                          </button>
                                        )}
                                      <button
                                        onClick={() =>
                                          inviteCallBack(
                                            "remove",
                                            item,
                                            item.networkMemberInfo[memberIndex]
                                              .userId
                                          )
                                        }
                                      >
                                        <RemoveIcon />
                                      {pageLanguageContents?.CreateGroup[20]?.Remove}
                                      </button>
                                    </BoxActionBtn>
                                  </>
                                )}

                              {!item.loggedInUserIsAdmin &&
                                item.networkMemberInfo[memberIndex].loggedIn &&
                                !item.networkMemberInfo[memberIndex].admin && (
                                  <BoxActionBtn>
                                    <button
                                      onClick={() =>
                                        inviteCallBack(
                                          "exit",
                                          item,
                                          item.networkMemberInfo[memberIndex]
                                            .userId
                                        )
                                      }
                                    >
                                      <RemoveIcon />
                                    {pageLanguageContents?.CreateGroup[21]?.ExitGroup}
                                    </button>
                                  </BoxActionBtn>
                                )}
                            </>
                          </AccordionHeader>
                        </>
                      ))}
                    </AccordionDetailsContainer>
                  </AccordionDetails>
                )}
              </>
            )}
            {item.loggedInUserIsAdmin && item.appearsInSearchResult && (
              <>
                {item.networkMemberInfo.length !== 0 && (
                  <AccordionDetails>
                    <AccordionDetailsContainer>
                      {item.networkMemberInfo.map((memberitem, memberIndex) => (
                        <AccordionHeader key={memberIndex}>
                          <GroupImageWrapper>
                            <Avatar
                              src={
                                item.networkMemberInfo[memberIndex].profileImage
                                  ? process.env.REACT_APP_API_URL +
                                  "/user/image/" +
                                  item.networkMemberInfo[memberIndex]
                                    .profileImage
                                  : ProfilePicture
                              }
                              alt="group-image"
                            />
                            <div>
                              {item.networkMemberInfo[memberIndex].loggedIn &&
                                item.networkMemberInfo[memberIndex].admin && (
                                  <>
                                    <h3>
                                    {pageLanguageContents?.CreateGroup[18]?.You} ({pageLanguageContents?.CreateGroup[17]?.Admin})
                                    </h3>

                                  </>
                                )}
                              {!item.networkMemberInfo[memberIndex].loggedIn &&
                                !item.networkMemberInfo[memberIndex].admin && (
                                  <>
                                    <h3>{memberitem.name}</h3>
                                  </>
                                )}
                              {!item.networkMemberInfo[memberIndex].loggedIn &&
                                item.networkMemberInfo[memberIndex].admin && (
                                  <>
                                    <h3>{memberitem.name} ({pageLanguageContents?.CreateGroup[17]?.Admin})</h3>
                                  </>
                                )}
                              {item.networkMemberInfo[memberIndex].loggedIn &&
                                !item.networkMemberInfo[memberIndex].admin && (
                                <h3>{memberitem.name}</h3>
                                )}
                            
                              <h3><small>{item.networkMemberInfo[memberIndex].locationName}</small></h3>
                              <h3><small>{item.networkMemberInfo[memberIndex].city}, {stateConvert(item.networkMemberInfo[memberIndex].state)}</small></h3>
                            </div>
                          </GroupImageWrapper>

                          {item.loggedInUserIsAdmin &&
                            item.networkMemberInfo[memberIndex].loggedIn && (
                              <>
                                <BoxActionBtn>
                                  {item.networkMemberInfo[memberIndex]
                                    .admin && (
                                      <button
                                        onClick={() => {
                                          inviteCallBack(
                                            "deleteGroup",
                                            item,
                                            item.networkMemberInfo[memberIndex]
                                              .userId
                                          );
                                          setExpanded(false);
                                        }}
                                      >
                                        <DeleteGroupIcon />
                                    {pageLanguageContents?.CreateGroup[19]?.DeleteGroup}
                                      </button>
                                    )}
                                  <button
                                    onClick={() =>
                                      inviteCallBack(
                                        "exit",
                                        item,
                                        item.networkMemberInfo[memberIndex]
                                          .userId
                                      )
                                    }
                                  >
                                    <RemoveIcon />
                                  {pageLanguageContents?.CreateGroup[21]?.ExitGroup}
                                  </button>
                                </BoxActionBtn>
                              </>
                            )}
                          {item.loggedInUserIsAdmin &&
                            !item.networkMemberInfo[memberIndex].loggedIn && (
                              <>
                                <BoxActionBtn>
                                  {!item.networkMemberInfo[memberIndex]
                                    .admin && (
                                      <button
                                        onClick={() =>
                                          inviteCallBack(
                                            "makeAdmin",
                                            item,
                                            item.networkMemberInfo[memberIndex]
                                              .authId
                                          )
                                        }
                                      >
                                        <MakeAdminIcon />
                                    {pageLanguageContents?.CreateGroup[22]?.MakeAdmin}
                                      </button>
                                    )}
                                  <button
                                    onClick={() =>
                                      inviteCallBack(
                                        "remove",
                                        item,
                                        item.networkMemberInfo[memberIndex]
                                          .userId
                                      )
                                    }
                                  >
                                    <RemoveIcon />
                                  {pageLanguageContents?.CreateGroup[20]?.Remove}
                                  </button>
                                </BoxActionBtn>
                              </>
                            )}

                          {!item.loggedInUserIsAdmin &&
                            item.networkMemberInfo[memberIndex].loggedIn &&
                            !item.networkMemberInfo[memberIndex].admin && (
                              <BoxActionBtn>
                                <button
                                  onClick={() =>
                                    inviteCallBack(
                                      "exit",
                                      item,
                                      item.networkMemberInfo[memberIndex].userId
                                    )
                                  }
                                >
                                  <RemoveIcon />
                                {pageLanguageContents?.CreateGroup[21]?.ExitGroup}
                                </button>
                              </BoxActionBtn>
                            )}
                        </AccordionHeader>
                      ))}
                    </AccordionDetailsContainer>
                  </AccordionDetails>
                )}
              </>
            )}
            {item.loggedInUserIsAdmin && !item.appearsInSearchResult && (
              <>
                {item.networkMemberInfo.length !== 0 && (
                  <AccordionDetails>
                    <AccordionDetailsContainer>
                      {item.networkMemberInfo.map((memberitem, memberIndex) => (
                        <AccordionHeader key={memberIndex}>
                          <GroupImageWrapper>
                            <Avatar
                              src={
                                item.networkMemberInfo[memberIndex].profileImage
                                  ? process.env.REACT_APP_API_URL +
                                  "/user/image/" +
                                  item.networkMemberInfo[memberIndex]
                                    .profileImage
                                  : ProfilePicture
                              }
                              alt="group-image"
                            />
                            <div>
                              {item.networkMemberInfo[memberIndex].loggedIn &&
                                item.networkMemberInfo[memberIndex].admin && (
                                  <>
                                    <h3>
                                    {pageLanguageContents?.CreateGroup[18]?.You} ({pageLanguageContents?.CreateGroup[17]?.Admin})
                                    </h3>
                                  </>
                                )}
                              {!item.networkMemberInfo[memberIndex].loggedIn &&
                                !item.networkMemberInfo[memberIndex].admin && (
                                  <>
                                    <h3>{memberitem.name}</h3>
                                  </>
                                )}
                              {!item.networkMemberInfo[memberIndex].loggedIn &&
                                item.networkMemberInfo[memberIndex].admin && (
                                  <>
                                  <h3>{memberitem.name} ({pageLanguageContents?.CreateGroup[17]?.Admin})</h3>

                                  </>
                                )}
                              {item.networkMemberInfo[memberIndex].loggedIn &&
                                !item.networkMemberInfo[memberIndex].admin && (
                                  <h3>{memberitem.name}</h3>
                                )}
                            
                              <h3><small>{item.networkMemberInfo[memberIndex].locationName}</small></h3>
                              <h3><small>{item.networkMemberInfo[memberIndex].city}, {stateConvert(item.networkMemberInfo[memberIndex].state)}</small></h3>
                            </div>
                          </GroupImageWrapper>

                          {item.loggedInUserIsAdmin &&
                            item.networkMemberInfo[memberIndex].loggedIn && (
                              <>
                                <BoxActionBtn>
                                  {item.networkMemberInfo[memberIndex]
                                    .admin && (
                                      <button
                                        onClick={() => {
                                          inviteCallBack(
                                            "deleteGroup",
                                            item,
                                            item.networkMemberInfo[memberIndex]
                                              .userId
                                          );
                                          setExpanded(false);
                                        }}
                                      >
                                        <DeleteGroupIcon />
                                    {pageLanguageContents?.CreateGroup[19]?.DeleteGroup}
                                      </button>
                                    )}
                                  <button
                                    onClick={() =>
                                      inviteCallBack(
                                        "exit",
                                        item,
                                        item.networkMemberInfo[memberIndex]
                                          .userId
                                      )
                                    }
                                  >
                                    <RemoveIcon />
                                  {pageLanguageContents?.CreateGroup[21]?.ExitGroup}
                                  </button>
                                </BoxActionBtn>
                              </>
                            )}
                          {item.loggedInUserIsAdmin &&
                            !item.networkMemberInfo[memberIndex].loggedIn && (
                              <>
                                <BoxActionBtn>
                                  {!item.networkMemberInfo[memberIndex]
                                    .admin && (
                                      <button
                                        onClick={() =>
                                          inviteCallBack(
                                            "makeAdmin",
                                            item,
                                            item.networkMemberInfo[memberIndex]
                                              .authId
                                          )
                                        }
                                      >
                                        <MakeAdminIcon />
                                    {pageLanguageContents?.CreateGroup[22]?.MakeAdmin}
                                      </button>
                                    )}
                                  <button
                                    onClick={() =>
                                      inviteCallBack(
                                        "remove",
                                        item,
                                        item.networkMemberInfo[memberIndex]
                                          .userId
                                      )
                                    }
                                  >
                                    <RemoveIcon />
                                  {pageLanguageContents?.CreateGroup[20]?.Remove}
                                  </button>
                                </BoxActionBtn>
                              </>
                            )}

                          {!item.loggedInUserIsAdmin &&
                            item.networkMemberInfo[memberIndex].loggedIn &&
                            !item.networkMemberInfo[memberIndex].admin && (
                              <BoxActionBtn>
                                <button
                                  onClick={() =>
                                    inviteCallBack(
                                      "exit",
                                      item,
                                      item.networkMemberInfo[memberIndex].userId
                                    )
                                  }
                                >
                                  <RemoveIcon />
                                {pageLanguageContents?.CreateGroup[21]?.ExitGroup}
                                </button>
                              </BoxActionBtn>
                            )}                        
                        </AccordionHeader>
                      ))}
                    </AccordionDetailsContainer>
                  </AccordionDetails>
                )}
              </>
            )}
          </Accordion>
        ))}
    </AccordionConatiner>
  );
};
export default GroupsAccordions;
